import axios from 'axios';
import { getHeaders } from '../../utils/apiUtils'; 

const API_BASE = process.env.REACT_APP_API_OPEN_SERVER;

export const fetchProductList = async (params, token, stime, secretKey) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    ...getHeaders(stime, secretKey, params),
  };

  const res = await axios.get(`${API_BASE}/v1/affiliate/portal/product`, {
    headers,
    params,
  });
  return res.data;
};

export const fetchProductConfig = async (token, stime, secretKey) => {

  const headers = {
    Authorization: `Bearer ${token}`,
    ...getHeaders(stime, secretKey),
  };

  const response = await axios.get(`${API_BASE}/v1/affiliate/portal/product/config`, {
    headers,
  });

  return response.data;
};

export const createProduct = async (data, token, stime, secretKey) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    ...getHeaders(stime, secretKey, data),
  };

  const res = await axios.post(`${API_BASE}/v1/affiliate/portal/product`, data, {
    headers,
  });

  return res.data;
};

export const UpdateStatus = async (data, token, stime, secretKey) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    ...getHeaders(stime, secretKey, data),
  };

  const res = await axios.patch(`${API_BASE}/v1/affiliate/portal/product`, data, {
    headers,
  });

  return res.data;
};